import View from '../src/index';
export default View;
